export enum TypeRevenueOverview {
    All = 0,
    Booking = 1,
    Service = 2,
    Product = 3,
    Package = 4,
    CashCard = 5,
    Debit = 6,
    Discount = 7,
}